import { createTypes, createAsyncTypes } from '../../utils';

const prefix = 'flashMessage';

const types = createTypes(prefix, [
    'SHOW_FLASH_MESSAGE',
    'HIDE_FLASH_MESSAGE',
    'SHOW_HEADER_FLASH_MESSAGE',
    'HIDE_HEADER_FLASH_MESSAGE',
    'REMOVE_SEEN_FLASH_MESSAGES'
]);

const asyncTypes = createAsyncTypes(prefix, [
    'FETCH_FLASH_MESSAGES',
    'CREATE_FLASH_MESSAGES'
]);

export default {
    ...types,
    ...asyncTypes
};
